import { Component, EventEmitter, Input, Output } from "@angular/core";

// @@angularMigrate wrong?
@Component({
    selector: 'pep-message-dialog',
    templateUrl: './pep-message-dialog.component.html',
    standalone: false
})

export class PepDialog {
    @Input() title: string;
    @Input() acceptButtonText: string;
    @Input() showCancelButton: boolean = true;

    @Input() valid: boolean = true;

    @Output() pushCancel = new EventEmitter<any>();
    @Output() pushAccept = new EventEmitter<any>();
    @Output() pushClose = new EventEmitter<any>();

    constructor() { }

    public cancel() {
        this.pushCancel.emit();
    }

    public accept() {
        this.pushAccept.emit();
    }

    public close() {
        this.pushClose.emit();
    }
}